<template>
  <div class="app-footer">
    <div class="app-footer__logo">
      <UkaskoLogo />
    </div>
    <div class="app-footer__sections">
      <div class="app-footer__section">
        <h4 class="app-footer__title">Виникли проблеми?</h4>
        <ul class="app-footer__list">
          <li
            v-for="(item, index) in getLinks('login', 'footer-links')"
            :key="index"
            class="app-footer__item"
          >
            <SmartLink
              class="app-footer__link"
              :url="item.url"
              :target="item.target"
            >
              {{ item.title }}
            </SmartLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { UkaskoLogo } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  mixins: [ textBlock ],
  components: { UkaskoLogo, SmartLink },
  methods: {
    getLinks(page, block) {
      const textBlock = this.getListBlock(page, block);
      return textBlock.map((item) => {
        return {
          title: item.text,
          url: item.url,
          target: item.target,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #313437;
  padding: 55px;
  overflow: hidden;

  @media (max-width: 1050px) {
    padding: 0 32px 32px;
  }

  &__logo {
    margin-bottom: 45px;
  }

  &__sections {
    display: flex;
    justify-content: space-between;

    @media (max-width: 1050px) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    @media (max-width: 600px) {
      flex-direction: column;
    }

    & > div {
      @media (max-width: 1050px) {
        width: 50%;
      }

      @media (max-width: 600px) {
        width: 100%;
      }
    }
  }

  &__section {
    @media (max-width: 1050px) {
      margin-bottom: 16px;
    }
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 22px;
    font-weight: 600;
    color: #FFFFFF;
    margin-bottom: 24px;
  }

  &__text, &__link {
    position: relative;
    display: inline-block;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #CADDFC;
    margin-bottom: 16px;
  }

  &__link {
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 0;
      background-color: #EB883B;
      transition: width 1s ease;
    }

    &:hover {
      color: #EB883B;

      &::after {
        width: 100%;
      }
    }
  }
}
</style>
